import { YN_TYPE } from "types/enumType";

export class UserSelectSearchRequest {
  localId: string;

  factoryId: string;

  deptId: string;

  searchKey: string;

  inHouseYn: YN_TYPE;

  notMineYn: YN_TYPE = YN_TYPE.N;

  page: number;

  count: number;

  activate?: YN_TYPE;

  constructor(page: number, count: number, localId: string, factoryId: string, deptId: string, inHouseYn: YN_TYPE = YN_TYPE.Y) {
    this.page = page;
    this.count = count;
    this.localId = localId ?? '';
    this.factoryId = factoryId;
    this.deptId = deptId;
    this.searchKey = '';
    this.inHouseYn = inHouseYn
  }
}
